var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "cancel-disabled": "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": "",
            "hide-header-close": "",
            title: _vm.getErrorTitle,
            "hide-footer": ""
          },
          model: {
            value: _vm.modalShow,
            callback: function($$v) {
              _vm.modalShow = $$v
            },
            expression: "modalShow"
          }
        },
        [
          !_vm.supportChatVisible
            ? _c("div", { staticClass: "text-center" }, [
                _c("div", { staticClass: "mx-auto error-img" }, [
                  _c("img", {
                    attrs: {
                      width: "96px",
                      height: "96px",
                      src: _vm.getErrorImg
                    }
                  })
                ]),
                _vm._v(" "),
                _c("p", {
                  staticClass: "text-center",
                  class: { "text-danger": !_vm.customError },
                  domProps: { innerHTML: _vm._s(_vm.getErrorMsg) }
                }),
                _vm._v(" "),
                !_vm.customError
                  ? _c("div", [
                      _c(
                        "a",
                        {
                          staticClass: "clickable small",
                          on: { click: _vm.toggleShowDetailedError }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.showDetailedError
                                ? _vm.$t("hide-detailed-error")
                                : _vm.$t("show-detailed-error")
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showDetailedError
                        ? _c("div", { staticClass: "code-format mt-2" }, [
                            _vm._v("\n          Error: "),
                            _c("b", [_vm._v(_vm._s(_vm.opentok.error.title))]),
                            _c("br"),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.opentok.error.msg) +
                                "\n        "
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.getCustomErrorBtnMsg !== ""
                  ? _c(
                      "div",
                      { staticClass: "col text-center pt-3" },
                      [
                        (_vm.smallToken = !"" && !_vm.getCustomErrorBtnMsg)
                          ? _c(
                              "b-button",
                              {
                                attrs: {
                                  center: "",
                                  "align-h": "center",
                                  variant: "outline-" + _vm.getErrorColorVariant
                                },
                                on: { click: _vm.pageReload }
                              },
                              [
                                _c("b-icon", {
                                  attrs: {
                                    icon: "arrow-counterclockwise",
                                    "aria-hidden": "true"
                                  }
                                }),
                                _vm._v(" " + _vm._s(_vm.$t("retry")))
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.getCustomErrorBtnMsg
                          ? _c(
                              "b-button",
                              {
                                attrs: {
                                  center: "",
                                  "align-h": "center",
                                  variant: "outline-" + _vm.getErrorColorVariant
                                },
                                on: { click: _vm.doCustomErrorAction }
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.getCustomErrorBtnMsg) +
                                    "\n        "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _c("div", [_c("hubspot-chat")], 1),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center mt-4" },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "outline-info", size: "sm" },
                  on: {
                    click: function($event) {
                      return _vm.$helpers.openSupportChat()
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.supportChatVisible
                        ? _vm.$t("back")
                        : _vm.$t("contact-by-chat-tech-problems")
                    )
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23316cdb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23316cdb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video-launcher/Error.vue
// module id = 2746
// module chunks = 28 43 45